<template>
	<div class="row progress-tracker flexible" :class="{'two-steps':steps.length === 2}">
		<slot name="left-control"></slot>
		<div class="flexible column relative">
			<div class="steps centered row">
				<div :style="{width: progressWidth}" class="line"></div>
				<div class="step column centering" v-for="(marker, index) in steps" v-bind:key="marker">
					<div class="dot rigid" :class="{'active':currentStep === marker, 'checked': index <= currentStepIndex || isComplete}" ></div>
					<small v-if="isReady" class="rigid">{{marker}}</small>
				</div>
			</div>
		</div>
		<slot name="right-control"></slot>
	</div>
</template>

<script>
export default {
	name: 'ProgressTracker',
	props: {
		steps: Array,
		currentStep: String,
		isComplete: Boolean
	},
	computed: {
		progressWidth() {
			if (this.isComplete) {
				return '100%';
			}
			const singleWidth = 100/(this.steps.length - 1);
			return (singleWidth * (this.currentStepIndex)) + '%';
		},
		currentStepIndex() {
			return this.getCurrentStepIndex();
		},
		isReady() {
			return this.currentStepIndex > 0 || this.isComplete;
		}
	},
	methods:{
		getCurrentStepIndex(){
			return this.steps.indexOf(this.currentStep);
		}
	}
};
</script>

<style scoped>
	.dot {
		height: 2rem;
    	width: 2rem;
		margin-top: -1em;
		border-radius: 50%;
		background-color: #fff;
	}
	.dark .dot,
	.dark .dot.active,
	.dark .dot.active:after {
		background-color: #1a1a1a;
	}

	.dot:not(.checked):after {
		content: '\F111';
		font-weight: 500;
	}

	.dot.active {
		background-color: #fff;
		color: #1bc0df;
	}

	.steps {
		justify-content: space-between;
		width: 100%;
		height: 4px;
		background: #ddd;
		margin: auto;
	}

	.step {
		z-index: 1;
		position: relative;
	}

	.dot + small {
		color: #999;
		position: absolute;
		margin-top: 1.5rem;
	}
	.dark .dot + small {
		color: #555;
	}

	.dot.checked + small {
		color: #333;
	}
	.dark .dot.checked + small {
		color: #999;
	}

	.line {
		content: '';
		
		background-color: #2E88D6;
		height: 4px;
		left: 0;
		position: absolute;
	}

	.dot.checked:after {
		content: '\F058';
		color: #2E88D6;
	}

	.dot:before {
		width: calc(100% / 2 - 2rem);
		height: 4px;
		color: black;
		content: '';
	}

	.dot:after {
		font-size: calc(2rem);
		font-weight: 900;
		border-radius: 50%;
		line-height: 2.1875rem;
		content: '\f192';
		color: #ddd;
		font-family: "Font Awesome 5 Free";
	}
	.dark .dot:after {
		color: #333;
	}

	.dot.checked:after {
		color: #2E88D6;
	}

	.dot.active:after {
		content: '\f192';
		font-weight: 500;
		background-color: #fff;
		color: ##7cb9ee;
	}

	.progress-tracker {
	    height: 2rem;
		margin: 1em auto 2em auto;
		max-width: 500px;
		width: 100%;
		max-width: 300px;
		overflow: visible;
	}

	.progress-tracker.two-steps {
		max-width: 200px;
	}

	.progress-tracker button:last-child {
		position: absolute;
		right: 0;
	}

	.progress-tracker footer.row {
		position: relative;
		height: 2em;
	}

	.dark .progress-tracker .steps {
		background: #333;
	}

</style>



// WEBPACK FOOTER //
// ./src/components/ProgressTracker.vue